var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_26185",
    "data-name": "Group 26185",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 153.889,
    height: 153.888,
    viewBox: "0 0 153.889 153.888",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.074,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#d286ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#8a19ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#6e14a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#480971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#6e14a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#974dc4",
    stopOpacity: 0.635
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.213,
    y1: 0.257,
    x2: 0.681,
    y2: 1.068,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffded"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11385",
    "data-name": "Group 11385",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "refresh"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18588",
    "data-name": "Path 18588",
    d: "M76.944,0A76.944,76.944,0,1,1,0,76.944,76.944,76.944,0,0,1,76.944,0Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18588_-_Outline",
    "data-name": "Path 18588 - Outline",
    d: "M76.944,6.318A70.627,70.627,0,0,0,27,126.885,70.627,70.627,0,1,0,126.885,27,70.164,70.164,0,0,0,76.944,6.318m0-6.318A76.944,76.944,0,1,1,0,76.944,76.944,76.944,0,0,1,76.944,0Z",
    transform: "translate(0 0)",
    fill: "#ffd055"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_18983",
    "data-name": "Path 18983",
    d: "M38.675,26.62,50.743,14.552A8.524,8.524,0,1,0,38.688,2.5L26.62,14.564,14.552,2.5A8.524,8.524,0,0,0,2.5,14.552L14.565,26.62,2.5,38.687A8.524,8.524,0,1,0,14.552,50.742L26.62,38.675,38.688,50.742A8.524,8.524,0,0,0,50.743,38.687Z",
    transform: "translate(76.944 39.296) rotate(45)",
    fill: "url(#linear-gradient-2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralPlus);
export default __webpack_public_path__ + "static/media/general-plus.e7664006b60d24599a02bf0cc7c8e72d.svg";
export { ForwardRef as ReactComponent };